import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'over70.dating',
  TITLE: 'Over 70 Dating',
  NICHE: 'over70',
  PROJECT: 'over70dating',
  NICHE_SINGULAR: 'over 70',
  NICHE_PLURAL: 'over 70',
  NICHE_SINGLES: 'Over 70 Singles',
  FB_TRACKING_PIXEL_ID: ['749073905427503'],
  BING_TRACKING_PIXEL: ['343094235'],
  SNAPCHAT_TRACKING_PIXEL: '5898340b-5bd4-431d-846e-065dd3b673f8',
  SNAPCHAT_HASHED_EMAIL:
    'e204fed6aff3d35c995bdf6883b099c14dd3b2271ade6d64169ddbfc29204e52',
  TYPE: 'mainstream',
  AGE_SLIDER_LOWER: 70,
  AGE_SLIDER_UPPER: 99,
  SENTRY_RELEASE: 'www-over70-dating',
  SENTRY_DNS:
    'https://dce8c11e84cb32be33abde296ff4a9c2@sentry.nearbyapi.com/12',
  VWO_ID: 302021,
  TABOOLA_TRACKING_PIXEL: '1730669',
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js